import { PageHeader as UIPageHeader, type PageHeaderProps } from '@ai-content-hub/ui';

/**
 * EAA-1820: every console page's `subtitle` collapses into an (i) beside the
 * title.
 *
 * These subtitles are standing explanations — what a screen is allowed to do,
 * what it deliberately does not cover — worth reading once and pure noise on
 * every visit after. Several ran three lines and pushed the page's actual
 * controls toward the fold.
 *
 * Defaulted HERE rather than passed on every page so a NEW page inherits it
 * without anyone remembering to. A page whose subtitle really is per-visit
 * information (a live count, a status) opts out with
 * `collapseSubtitle={false}` — the prop still wins, since it spreads after.
 *
 * Its own file, not the barrel: a barrel that exports a component alongside
 * constants breaks Fast Refresh for everything in it.
 */
export function PageHeader(props: PageHeaderProps) {
    return <UIPageHeader collapseSubtitle {...props} />;
}

export default PageHeader;
